import { render, staticRenderFns } from "./UserConf.vue?vue&type=template&id=79ff580a&scoped=true&"
import script from "./UserConf.vue?vue&type=script&lang=js&"
export * from "./UserConf.vue?vue&type=script&lang=js&"
import style0 from "./UserConf.vue?vue&type=style&index=0&id=79ff580a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ff580a",
  null
  
)

export default component.exports